/* global game, Phaser, social */

var bootState = {

	preload: function() {

		game.load.image( 'progressBar', '/assets/games/pixel-peak/images/loading.png' );

		this.scale.pageAlignHorizontally = true;

		this.scale.pageAlignVertically = true;

		// Make game stretch to fill screen fully
		game.scale.scaleMode = Phaser.ScaleManager.SHOW_ALL;
		game.renderer.renderSession.roundPixels = true;

		Phaser.Canvas.setImageRenderingCrisp( game.canvas );

		// update game scale
		game.scale.refresh();

		// Set a background color and the physic system
		game.stage.backgroundColor = '#45283c';

		game.stage.smoothed = false;

	},

	create: function() {

		// switch to the loading state
		game.state.start( 'load' );

	}

};
